/**
 * Hook: is the current user a Product admin?
 *
 * Mirrors server-side `isProjectsAdmin` in functions/src/lib/roles.ts:
 *   app/hub admin, super-admin, OR tools.projects.role ∈ {approver, approver_admin}.
 */
import { useProfile } from '../profile/ProfileProvider';

export function useIsProjectsAdmin(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  if (state.isAdmin) return true;
  if (state.user.hubRole === 'admin' || state.user.hubRole === 'super_admin') return true;
  const role = state.user.tools?.projects?.role;
  return role === 'approver' || role === 'approver_admin';
}
